import { Badge } from "@/components/ui/badge";
import moment from "moment";
import getUnidade from "@/utils/getUnidade";
import obterRespostaByArray from "@/utils/obterRespostaByArray";
import getServico from "@/utils/getServico";
import { ScrollArea } from "@/components/ui/scroll-area";
import { TooltipEasy } from "@/components/tooltipEasy";
import { User, UserCheck } from "lucide-react";
import { ItemEquipe } from "./ItemEquipe";
import getPrazo from "@/utils/getPrazo";
import { EmptyData } from "./EmptyData";

export function CardEquipe({ setor, solicitacoes, total_finalizados, total_andamento, ultimo_registro, unidadeId }) {

  if (solicitacoes?.length === 0) return <div className="hidden" />

  return (
    <div className="relative bg-[#f3f4f5] rounded-md min-h-[410px] border border-[#e2e8f0]">
      <div className="flex items-center gap-1 absolute top-2 right-2">
        <TooltipEasy content="Quantidade de finalizados"><Badge className="bg-emerald-600 text-white">{total_finalizados} <UserCheck /></Badge></TooltipEasy>
        <TooltipEasy content="Quantidade em andamento"><Badge className="bg-[#717171] text-white">{total_andamento} <User /></Badge></TooltipEasy>
      </div>
      <div className="pb-2  p-4 ">
        <p className="font-bold text-base">{setor}</p>
        <p className="text-[12px]">{ultimo_registro ? `Último atendimento ${ultimo_registro}` : "Sem último atendimento"}</p>
      </div>

      <ScrollArea className="h-[320px] px-4">
        <div className="flex flex-col gap-2">
          {solicitacoes?.length === 0 && <EmptyData />}
          {solicitacoes.map(item => (
            <ItemEquipe
              key={item._id}
              id={item._id}
              tempo_ate_agora={moment(item.createdAt).fromNow()}
              nome_aluno={obterRespostaByArray(item.solicitacao, "nome_completo")}
              servico={getServico(item.setor, item.servico)}
              atendente={item.atendente_info?.nome ?? "Sem Atendente"}
              unidade={getUnidade(item.atendente_info?.empresa)}
              setorId={item.setor}
              servicoId={item.servico}
              prazo={getPrazo(item.setor, item.servico)}
              createdAt={item.createdAt}
              unidadeId={unidadeId}
            />
          ))}
        </div>
      </ScrollArea>


    </div>
  )
}